export default __webpack_public_path__ + "static/media/BlueLand.c5f5331e.png";